export enum SQLQueryParamOperatorEnum {
  UNEQ = '<>',
  EQ = '=',
  GE = '>=',
  G = '>',
  LE = '<=',
  L = '<',
  LIKE = 'like',
  IS_NULL = 'is null',
  IS_NOT_NULL = 'is not null',
}
